import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpenMobileMenuModal: false,
  newsUser: "",
  isOpenAd: true,
};

const ConsoleReducer = createSlice({
  name: "ConsoleReducer",
  initialState: initialState,
  reducers: {
    openMobileMenuModal: (state) => {
      return {
        ...state,
        isOpenMobileMenuModal: true,
      };
    },
    setNewsUser: (state, { payload }) => {
      return {
        ...state,
        newsUser: payload,
      };
    },
    closeMobileMenuModal: (state) => {
      return {
        ...state,
        isOpenMobileMenuModal: false,
      };
    },
    openHomeAdModal: (state) => {
      return {
        ...state,
        isOpenAd: true,
      };
    },
    closeHomeAdModal: (state) => {
      return {
        ...state,
        isOpenAd: false,
      };
    },
  },
});
export default ConsoleReducer;
